import { Reports } from '@optitrac/components';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../service/userContext';
import { AllUser, Department } from './report.type';
import { toast } from 'react-toastify';
import { Asset, GroupedAsset } from '../../../utils/types';
import { fetch as customFetch } from '../../../utils/api';
import { API_METHODS } from '../../../dustControl/utils/constants';
import {
  Endpoint,
  getUrl,
} from '../../../materialMovements/pages/shiftLoader/helper';
import { useNavigate } from 'react-router-dom';
import { groupAssetsByCategory } from '../../../utils/helper';
import { LicenseData } from '../types';
import { CallWithAuth } from '../../service/apiActions';
import {
  GET_MATERIALS,
  GET_SOURCE_DUMPS,
} from '../../../materialMovements/action/apiPath';

const ReportsPage = () => {
  const [assetData, setAssetData] = useState<GroupedAsset[]>([]);
  const { departments, userInfo } = useContext(UserContext);
  const {
    licenses,
    allUsers,
    fetchAllUsers,
  }: { licenses: LicenseData[]; allUsers: AllUser; fetchAllUsers: any } =
    useContext(UserContext);

  useEffect(() => {
    fetchAllUsers();
  }, [fetchAllUsers]);

  const departmentOption = departments.map((item: Department) => ({
    name: item.name,
    value: item.name,
    code: item.code,
  }));

  const navigate = useNavigate();
  const handleNavigate = (): void => navigate('/');

  useEffect(() => {
    const fetchAllTrucks = async (): Promise<void> => {
      try {
        const response = await customFetch<Asset[]>({
          method: API_METHODS.GET,
          endPoint: Endpoint.getTrucks,
          navigateToLoginPage: () => navigate('/'),
        });

        const assetResponse: Asset[] = response.data;
        const assets = groupAssetsByCategory(assetResponse);
        setAssetData(assets);
      } catch (error: any) {
        toast.error(error?.message);
      }
    };

    fetchAllTrucks();
  }, []);

  return (
    <Reports
      allUserData={allUsers}
      licensesData={licenses}
      departmentData={departmentOption}
      assetData={assetData}
      userInfoData={userInfo}
      fetch={customFetch}
      speedEventsApiEndpoint={getUrl(Endpoint.getSpeedEvents)}
      navigateToLoginPage={handleNavigate}
      assetEventsApiEndpoint={getUrl(Endpoint.getAssetEvents)}
      maxSpeedEventsApiEndpoint={getUrl(Endpoint.getMaxSpeedEvents)}
      getParkingzoneEventApiEndPoint={getUrl(Endpoint.getParkingZones)}
      publicLambdaBaseUrl={getUrl()}
      getParkingEventApiEndPoint={getUrl(Endpoint.getParkingEvent)}
      getListTemplatesApiEndpoint={getUrl(Endpoint.getGetListTemplatesEvents)}
      CallWithAuth={CallWithAuth}
      assetUtiliseApiEndpoint={getUrl(Endpoint.getAssetUtilise)}
      engineHourEndPoint={getUrl(Endpoint.getEngineHourDayNight)}
      downloadReportApiEndPoint={getUrl(Endpoint.downloadReport)}
      getReportApiEndPoint={getUrl(Endpoint.getReportApiEndPoint)}
      materialMovementsApiEndpoint={Endpoint.getMaterialMovementLoads}
      cameraDistance={4814}
      maxZoom={4815}
      mapCenter={{ lat: -37.202865, long: 174.729095 }}
      getsourcedumpsApiEndpoint={GET_SOURCE_DUMPS}
      getMaterialDetailsApiEndpoint={GET_MATERIALS}
    />
  );
};

export default ReportsPage;
